import ReactApexChart from 'react-apexcharts';
import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

const StatusDonutChart = ({
    segments = [],
    subtitle,
    t,
    title,
    total,
    totalLabel,
}) => {
    const chartOptions = {
        labels: segments.map((segment) => t(segment.label)),
        colors: segments.map((segment) => segment.color),
        chart: {
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '72%',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '13px',
                            fontWeight: 500,
                            color: '#74788D',
                            offsetY: -4,
                        },
                        value: {
                            show: true,
                            fontSize: '22px',
                            fontWeight: 700,
                            color: '#1D1D1D',
                            offsetY: 8,
                        },
                        total: {
                            show: true,
                            showAlways: true,
                            label: t(totalLabel),
                            fontSize: '13px',
                            fontWeight: 500,
                            color: '#74788D',
                            formatter: () => String(total),
                        },
                    },
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: true,
            position: 'right',
            horizontalAlign: 'center',
            itemMargin: {
                vertical: 4,
            },
            markers: {
                width: 10,
                height: 10,
                radius: 10,
            },
            formatter: (label, options) => (
                `${label}   ${options.w.globals.series[options.seriesIndex]}`
            ),
        },
        stroke: {
            width: 0,
        },
        responsive: [
            {
                breakpoint: 1200,
                options: {
                    legend: {
                        position: 'bottom',
                    },
                },
            },
        ],
    };

    return (
        <Card className="h-100 mb-0">
            <CardBody>
                <CardTitle tag="h6" className="mb-1">
                    {t(title)}
                </CardTitle>

                <p className="text-muted font-size-12 mb-3">
                    {t(subtitle)}
                </p>

                <div className="apex-charts">
                    <ReactApexChart
                        options={chartOptions}
                        series={segments.map((segment) => segment.value)}
                        type="donut"
                        height="250"
                    />
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    StatusDonutChart
);
